// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBn80DXQu8-H8HHl6PzARAlSwv-3aAO1Q0",
  authDomain: "rocharamascnc.firebaseapp.com",
  projectId: "rocharamascnc",
  storageBucket: "rocharamascnc.firebasestorage.app",
  messagingSenderId: "496193550382",
  appId: "1:496193550382:web:efd6d86ba0703e2134c7bf",
  measurementId: "G-QY0VFBBCEQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const rtdb = getDatabase(app);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");

export { app, analytics, db, auth, googleProvider, rtdb, storage, functions };